import React from 'react'
import PropTypes from 'prop-types'
import { getProperties } from './functions'
import { useMediaQuery } from '@uidotdev/usehooks'

ParallaxPicture.propTypes = {
  data: PropTypes.object,
}

export default function ParallaxPicture({ data }) {
  const isMobile = useMediaQuery('only screen and (max-width: 768px)')
  const isTablet = useMediaQuery('only screen and (min-width : 768px) and (max-width : 1280px)')

  const {
    containerStyles,
    backgroundStyle,
    overlayStyles,
    imageWithContent,
    label,
    title,
    description,
    overlayClass,
  } = getProperties({
    data,
    isMobile,
    isTablet,
  })

  return (
    <section className={containerStyles} style={backgroundStyle}>
      <div style={overlayStyles} className={overlayClass}>
        <div className="main-container h-full flex flex-col justify-center">
          {imageWithContent ? (
            <div className="mt-[137px] mb-[137px] 2xl:mt-[146px] 2xl:mb-[146px]">
              <span className="uppercase paragraph text-isabelline text-xl">{label}</span>
              <h3 className="heading2 uppercase text-isabelline text-[45px] leading-[45px] lg:text-[70px] lg:leading-[70px]  ">
                {title}
              </h3>
              {description ? (
                <p className="heading4 pt-[28px]  text-isabelline text-lg font-light  leading-[25.47px] lg:text-3xl lg:leading-[41.31px]">
                  {description}
                </p>
              ) : null}
            </div>
          ) : null}
        </div>
      </div>
    </section>
  )
}
